import api from './axiosConfig';

export interface PermissionDto {
  id: string;
  permissionName: string;
  description: string;
  module: string;
}

export interface RolePermissionDto {
  roleId: string;
  roleName: string;
  description: string;
  isActive: boolean;
  isSelectableInEmployeeProfile: boolean;
  permissions: PermissionDto[];
}

export interface CreateRoleRequest {
  roleName: string;
  description: string;
  isSelectableInEmployeeProfile: boolean;
  permissionIds: string[];
}

export interface UpdateRoleRequest {
  id: string;
  roleName: string;
  description: string;
  isActive: boolean;
  isSelectableInEmployeeProfile: boolean;
}

export interface AssignPermissionsRequest {
  roleId: string;
  permissionIds: string[];
}

export interface CreatePermissionRequest {
  permissionName: string;
  description: string;
  module: string;
}

export interface UpdatePermissionRequest {
  id: string;
  permissionName: string;
  description: string;
  module: string;
}

export interface EmployeeLookupDto {
  id: string;
  name: string;
}

export interface EmployeeProfileRoleLookupDto {
  roleId: string;
  roleName: string;
  employees: EmployeeLookupDto[];
}

export const rolesApi = {
  getRolesWithPermissions: async (): Promise<RolePermissionDto[]> => {
    const response = await api.get<RolePermissionDto[]>('/roles');
    return response.data;
  },

  getRolePermissions: async (roleId: string): Promise<RolePermissionDto> => {
    const response = await api.get<RolePermissionDto>(`/roles/${roleId}/permissions`);
    return response.data;
  },

  getAllPermissions: async (): Promise<PermissionDto[]> => {
    const response = await api.get<PermissionDto[]>('/roles/permissions');
    return response.data;
  },

  getEmployeeProfileRoles: async (): Promise<EmployeeProfileRoleLookupDto[]> => {
    const response = await api.get<EmployeeProfileRoleLookupDto[]>('/roles/employee-profile');
    return response.data;
  },

  createRole: async (data: CreateRoleRequest): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/roles', data);
    return response.data;
  },

  updateRole: async (id: string, data: UpdateRoleRequest): Promise<void> => {
    await api.put(`/roles/${id}`, data);
  },

  deleteRole: async (id: string): Promise<void> => {
    await api.delete(`/roles/${id}`);
  },

  assignPermissions: async (roleId: string, data: AssignPermissionsRequest): Promise<void> => {
    await api.put(`/roles/${roleId}/permissions`, data);
  },

  // Permission CRUD
  createPermission: async (data: CreatePermissionRequest): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/roles/permissions', data);
    return response.data;
  },

  updatePermission: async (id: string, data: UpdatePermissionRequest): Promise<void> => {
    await api.put(`/roles/permissions/${id}`, data);
  },

  deletePermission: async (id: string): Promise<void> => {
    await api.delete(`/roles/permissions/${id}`);
  },
};
